import { useTranslation } from 'react-i18next';
import { useChannelAfterCrud } from '@/shared/hooks';
import { useBoundStore } from '@/shared/store';

export function useLangSwitcher() {
  const { i18n } = useTranslation();
  const { emitSuccessAction } = useChannelAfterCrud({});
  const setLng = useBoundStore((state) => state.setLng);

  const toggle = async () => {
    const nextLang = i18n.language === 'uz' ? 'ru' : 'uz';
    await i18n.changeLanguage(nextLang);
    setLng(nextLang);
    emitSuccessAction();
  };

  return {
    toggle,
  };
}
